/* eslint-disable */
import type GoogleMapReact from 'google-map-react';
import useSupercluster from 'use-supercluster';
import type { PointFeature } from 'supercluster';
import type Supercluster from 'supercluster';
import { memoize } from 'lodash';
import type { Coordinates } from '@volkswagen-onehub/audi-feature-service-visitor-locator';
import { useSetMapZoomAndCenterCoordinates } from '../Map/Map.hooks';
import type { Dealer } from '../../../models/dealer';

const DEFAULT_RADIUS = 50;
const DEFAULT_MAX_ZOOM = 20;

export type BOX = [number, number, number, number];

export type Cluster = Dealer & { cluster: boolean; point_count: number };

const transformBoundsToBox = (bounds: GoogleMapReact.Bounds): BOX => [
  bounds.nw.lng,
  bounds.se.lat,
  bounds.se.lng,
  bounds.nw.lat,
];

const getMapPoints = memoize((dealers: Dealer[] = []): PointFeature<Cluster>[] =>
  dealers.map((dealer) => ({
    type: 'Feature',
    properties: {
      cluster: false,
      point_count: 0,
      ...dealer,
    },
    geometry: {
      type: 'Point',
      coordinates: [dealer.longitude, dealer.latitude],
    },
  })),
);

export const useCluster = (
  dealers: Dealer[],
  bounds: GoogleMapReact.Bounds,
  zoom: number,
  groupMarkers: boolean,
) => {
  const points = getMapPoints(dealers);

  const { clusters, supercluster } = useSupercluster({
    points,
    bounds: transformBoundsToBox(bounds),
    zoom,
    options: { radius: DEFAULT_RADIUS, maxZoom: DEFAULT_MAX_ZOOM },
  });

  return { clusters: groupMarkers ? clusters : points, supercluster };
};

export const handleClusterClick = (supercluster: Supercluster | undefined) => {
  const setMapZoomAndCenterCoordinates = useSetMapZoomAndCenterCoordinates();

  return (clusterId: number, coordinates: Coordinates) => {
    const expansionZoom = Math.min(supercluster?.getClusterExpansionZoom(clusterId) || 1, 20);
    setMapZoomAndCenterCoordinates(expansionZoom, coordinates);
  };
};
